import React, { useEffect, useState } from 'react';

import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FilterListIcon from '@mui/icons-material/FilterList';
import StationItem from './StationItemUpdate';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useNavigate } from 'react-router-dom';

const Station = (props) => {
  const { GET_USER, currentUser, highlightString, showOnlyString, hiddenString, iconUrl, id, items, mealName, name, notes, favorites, params, dateFull } = props;
  const [isShowingDialog, setIsShowingDialog] = useState(false);
  const [hiddenCount, setHiddenCount] = useState(0);
  
  //console.log('station', items);

  let navigate = useNavigate();

  const isShowingDialogToggle = () => {
    setIsShowingDialog(!isShowingDialog);
  }

  const routeChange = (path) => {
    navigate(path);
  }

  useEffect(() => {
    let count = 0;
    if (items.length > 0) {
      items.forEach((x) => {
        if (x.item.isHiddenForCurrentUser) {
          count = count + 1;
        }
      });
      setHiddenCount(count);
    }
  }, [items])

  let hiddenDialog = [];
  let itemMap;
  let hiddenMessage = "";
  let highlightMessage = "";

  itemMap = items.map((x) => {
    let item = x.item;
    if (item.isHiddenForCurrentUser) {
      hiddenDialog.push(<StationItem 
        params={params}
        mealName={mealName}
        dateFull={dateFull}
        favorites={favorites} 
        GET_USER={GET_USER} 
        currentUser={currentUser} 
        specialName={x.specialName} 
        itemMenuId={x.itemMenuId}
        linkToMenuId={x.hasComponents}
        hasComponents={x.hasComponents}
        className={"station-item-hidden-true"} 
        key={item.itemId} 
        {...item} 
        />)
        return null;
    } else {
      return <StationItem 
        params={params}
        dateFull={dateFull}
        mealName={mealName}
        favorites={favorites} 
        GET_USER={GET_USER} 
        currentUser={currentUser}
        itemMenuId={x.itemMenuId}
        linkToMenuId={x.hasComponents}        
        hasComponents={x.hasComponents}
        specialName={x.specialName}
        key={item.itemId} 
        {...item} 
       />
    }
  });

  // Rework this logic; I think the data is gathered differently
  
  if (highlightString !== '') {
    highlightMessage = <span> You have marked <span className='selected-filter-settings'>{highlightString}</span> as being <span className='filter-settings-highlight'>highlighted</span>.</span>
  }

  if (showOnlyString !== '' && hiddenString !== '') {
    hiddenMessage = <>These food items are hidden according to your menu settings. You have <span className="selected-filter-settings">{hiddenString}</span>marked as <span className="filter-settings-hidden">'Must Not Have'</span> and <span className="selected-filter-settings">{showOnlyString}</span> marked as <span className="filter-settings-showonly">'Must Have'</span>. If a food item contains a trait marked as <span className="filter-settings-hidden">'Must Not Have'</span> or if there is no nutritional information available for an item, it will be hidden from the menu. If a food item does not contain a trait marked as <span className="filter-settings-showonly">'Must Have'</span> it will also be hidden from the menu.{highlightMessage !== "" ? (highlightMessage) : ""}</>
  } else if (hiddenString !== '') {
    hiddenMessage = <>These food items are hidden according to your menu settings. You have <span className="selected-filter-settings">{hiddenString}</span>marked as <span className="filter-settings-hidden">'Must Not Have'</span>. If a food item contains a trait marked as <span className="filter-settings-hidden">'Must Not Have'</span> or if there is no nutritional information available for an item, it will be hidden from the menu.{highlightMessage !== "" ? (highlightMessage) : ""}</>
  } else if (showOnlyString !== '') {
    hiddenMessage = <>These food items are hidden according to your menu settings. You have <span className="selected-filter-settings">{showOnlyString}</span> marked as <span className="filter-settings-showonly">'Must Have'</span>. If a food item does not contain a trait marked as <span className="filter-settings-showonly">'Must Have'</span> it will be hidden from the menu.{highlightMessage !== "" ? (highlightMessage) : ""}</>
  }

  const StationIcon = () => {
    if (iconUrl) {
      return <img src={iconUrl} className="station-icon" alt={name + " station icon"} />
    } else {
      return null;
    }
  }

  const StationName = () => {
    return name
  }

  const StationNotes = () => {
    if (notes !== "") {
      return <p className="station-notes">{notes}</p>
    } else {
      return null;
    }
  }

  return (
    <div className="station" key={id}>
      <div className="station-container">
        <div className="station-name">
          <StationIcon />
          <StationName />
          <StationNotes />
        </div>

        <div className="station-items">{itemMap}</div>
        {hiddenCount !== 0 ? <Button
          variant='outlined'
          color="secondary"
          size="large"
          startIcon={<VisibilityOffIcon aria-hidden="true" />}
          fullWidth
          onClick={isShowingDialogToggle}
        >
          View {hiddenDialog.length} hidden item{hiddenDialog.length > 1 ? "s" : null}
        </Button> : null}
        <Dialog
          onClose={isShowingDialogToggle}
          open={isShowingDialog}
          fullWidth={true}
          maxWidth={'md'}
          aria-labelledby="hidden-items-dialog-title"
          aria-describedby="hidden-items-dialog-description"
        >
          <DialogTitle id="hidden-items-dialog-title">{name} Hidden Items</DialogTitle>
          <DialogContent>
            <DialogContentText id="hidden-items-dialog-description">
              {hiddenMessage}
            </DialogContentText>
            {hiddenDialog}
          </DialogContent>
          <DialogActions>
            <Button
              variant='outlined'
              color="secondary"
              size="large"
              startIcon={<FilterListIcon aria-hidden="true" />}
              onClick={() => routeChange('/settings/')}
            >
              Modify filters
            </Button>
            <Button
              variant='outlined'
              color="error"
              size="large"
              startIcon={<CloseIcon aria-hidden="true" />}
              onClick={isShowingDialogToggle}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}


export default Station;